module.exports = __webpack_public_path__ + "img/PhönixAusDerAsche.4ec85c4f.jpg";